module.exports = __webpack_public_path__ + "static/media/prof-it.e4e08aa5.svg";